"use client";
import { getItem, removeItem, setItem } from "./encryptedStorage";

// Marks a session that was started by an Illumine handoff instead of an Auth0 login.
// A handoff session holds a Firebase session on Bookingo's own project — the API accepts
// an ID token from that project in place of an Auth0 access token — so the single bearer
// resolution in okta/page.ts has to know which of the two this session owns.
// The stored value is the centerId the handoff resolved, so the marker is self
// describing while debugging.
const handoffSessionKey = "handoffSession";

function setHandoffSession(centerId: string) {
    setItem(handoffSessionKey, centerId);
}

function isHandoffSession() {
    return !!getItem(handoffSessionKey);
}

function clearHandoffSession() {
    removeItem(handoffSessionKey);
}

export { handoffSessionKey, setHandoffSession, isHandoffSession, clearHandoffSession };
